import { render, staticRenderFns } from "./losaprily-card-banner.vue?vue&type=template&id=6028f70b&scoped=true&"
import script from "./losaprily-card-banner.vue?vue&type=script&lang=js&"
export * from "./losaprily-card-banner.vue?vue&type=script&lang=js&"
import style0 from "./losaprily-card-banner.vue?vue&type=style&index=0&id=6028f70b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028f70b",
  null
  
)

export default component.exports